import type { ApiError } from './types';

export function mapProblemToFormErrors(err: ApiError): Record<string, string> {
  if (!err.fieldErrors) return {};
  return Object.fromEntries(
    Object.entries(err.fieldErrors).map(([field, messages]) => [field, messages[0] ?? ''])
  );
}
